export const deleteAllCookies = () => {
    const cookies = ['b__ac', 'b__ap', 'b__ly', 'c__vt', 'c__ct', 'c__et'];
    for (var cookie of cookies) {
        document.cookie = [`${cookie}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/;`].join('');
    }
}